"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialSecurityNumberValidator = void 0;
const api_1 = require("../utils/api");
const utils_1 = require("./utils");
const validator_1 = require("./validator");
const maxCacheAge = 5 * 60 * 1000; // 5 minutes
const cache = new Map();
class SocialSecurityNumberValidator extends validator_1.CommonValidator {
    merge(props = {}) {
        return new SocialSecurityNumberValidator({ ...this.props, ...props });
    }
    unique(unique = true) {
        return this.merge({ unique });
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [this.validateFormat, this.validateUnique]
        });
    };
    validateFormat = async ({ ctx, next }) => {
        const value = ctx.value.replace(/[\s-]/g, "");
        if (value.length === 9 && value === value.replace(/[^\d]/g, "")) {
            let sum = 0;
            for (let i = 0; i < 8; i++) {
                const n = parseInt(value[i], 10);
                sum += (i + 1) % 2 === 0 ? n * 7 : n * 3;
            }
            const n = parseInt(value[8], 10);
            const cdv = sum % 10;
            if (n === cdv) {
                return next();
            }
        }
        ctx.addError({ format: "social-security-number" });
    };
    validateUnique = async ({ rootCtx, ctx, next }) => {
        const unique = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.unique);
        if (unique !== true) {
            return next();
        }
        const { value } = ctx;
        const ts = cache.get(value);
        const isCached = ts !== undefined && Date.now() - ts <= maxCacheAge;
        if (!isCached) {
            cache.delete(value);
            try {
                await api_1.api.get(`/ssn/${value}`);
            }
            catch (e) {
                if ("response" in e && e.response.status === 404) {
                    return next();
                }
                else {
                    throw e;
                }
            }
            cache.set(value, Date.now());
        }
        ctx.addError({ unique: false });
    };
}
exports.SocialSecurityNumberValidator = SocialSecurityNumberValidator;
